(() => {
  if (customElements.get('cart-drawer-upsell')) {
    return;
  }

  class CartDrawerUpsell extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('cart-drawer-upsell')?.innerHTML;

          document.querySelector('cart-drawer-upsell').innerHTML =
            innerHTML;

          this.slider = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 2.5,
            spaceBetween: 10,
            slidesOffsetBefore: 10,
            slidesPerGroup: 2,
            pagination: {
              el: '.cart-drawer__upsell .swiper-pagination',
              type: 'bullets',
            },
          })

          document.querySelectorAll('.cart-drawer__upsell .size-box-trigger').forEach(function(childElement) {
            childElement.addEventListener('click', function(event) {
              childElement.parentElement.parentElement.querySelector('.variants-box-container').toggleAttribute('open');
            });
          });
        });
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
})();
